import { useState, useEffect } from 'react';
import dayjs from 'dayjs';
import { useStores } from '../../hooks/stores';

export const useAuthStore = () => {
  const { authStore } = useStores();
  return authStore;
};

export const useTimer = (format = 'ddd DD.MM.YYYY / hh:mm:ss') => {
  const [time, setTime] = useState(dayjs().format(format));

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(dayjs().format(format));
    }, 1000);

    return () => clearInterval(interval);
  }, [format]);

  return time;
};
